module.exports = __webpack_public_path__ + "img/check-circle.b254df18.png";